<template>
    <div id="mainpage">
        <Navbar />
        <section class="hero has-background-transparent">
            <div id="curr_view" class="hero-body">
                <div>
                    <router-link to="/"><img height="290" width="280" alt="CRRPSA logo" src="./assets/logo.png"></router-link>
                </div>
            </div>
        </section>
        <template v-if="currentRouteName === 'home'">
            <div class="has-background-transparent px-3">
                <div class="columns has-text-left">
                    <br><br>
                    <div class="column is-12">
                        <router-view></router-view>
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="has-background-white-bis px-3"><br>
                <div class="columns has-text-left">
                    <br><br>
                    <div class="column is-10 is-offset-1 pb-6" id="routerview">
                        <router-view></router-view>
                    </div>
                </div>
            </div>
        </template>
        <template>
            <div class="main-wrapper">
                <cookie-law theme="royal" buttonText="OK" message="Ce site utilise des cookies afin d'améliorer votre expérience utilisateur"></cookie-law>
            </div>
        </template>
        <footer class="has-background-light has-text-dark">
            <img height="50" width="66" alt="CRRPSA logo" src="./assets/logo_partial.png">
            <p class="test ">Centre Ressource Régional de Psychiatrie du Sujet Âgé (CRRPSA) - Île-de-France</p>
            <p class="footerlinks">
                <span class="mr-2">2021 <span v-if=" new Date().getFullYear() > 2021 "> - {{ new Date().getFullYear() }}</span></span> | <router-link to="/page/liens-utiles#read">Liens utiles</router-link> | <router-link to="/page/mentions-legales#read">Mentions légales</router-link>
            </p>
        </footer>
        <go-top name="remonter" :size="50" :bottom="40" :max-width="300" ></go-top>
    </div>
</template>
<script>
import Navbar from './components/Menu2.vue'
import CookieLaw from 'vue-cookie-law'
import GoTop from '@inotom/vue-go-top';

export default {
    data: function() {
        return {
            flip: true,
            inscriptions: true,
        }
    },
    name: 'App',
    components: {
        Navbar,
        CookieLaw,
        GoTop,
    },
    computed: {
        currentRouteName() {
            return this.$route.name;
        }
    },
    methods: {
        scrollToTop() {
            window.scrollTo(0, 0);
        }
    }

}
</script>
<style>
@import url('https://fonts.googleapis.com/css2?family=Roboto+Slab:wght@200;400&display=swap');

h1,
h3 {
    line-height: 1.4em !important;
}

h1:after,
h3:after {
    content: "";
    display: block;
    width: 70px;
    /*border-bottom: 6px solid #ffd91c;*/
    border-bottom: 6px solid #ff3860;
    margin-bottom: 5px;
}


#mainpage {
    /*font-family:'Roboto Slab', serif Avenir, Helvetica, Arial, sans-serif;*/
    font-family: 'Roboto Slab', serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 0px;
}

.barre {
    text-decoration: line-through;
}

footer {
    border-top: 2px solid #ddd;
    background-color: hsl(0, 0%, 29%);
    padding-top: 40px;
    padding-bottom: 10px;
}

.footerlinks a {
    color: #aaa;
    padding: 10px;
}

.footerlinks a:hover {
    color: black;
    text-decoration: underline;
}

/* You could use :after - it doesn't really matter */
#curr_view {
    width: 100%;
    height: 320px;
    display: block;
    position: relative;
    border-bottom: 0px solid #ddd;
    box-shadow: 1px 1px 12px #555;
    background-color: transparent;
}

#curr_view:after {
    content: ' ';
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: -10;
    opacity: 0.2;
    background-image: url('./assets/entree.jpg');
    background-repeat: no-repeat;
    background-position: 50% 0;
    background-size: cover;
}

#map_access iframe {
    height: 500px !important;
}

</style>